import React from 'react';
import { getFirstImageUrl } from '../utils/imageUtils';

export default function PropertyModal({ property, onClose }) {
    if (!property) return null;

    const imageUrl = getFirstImageUrl(property.fotos);

    return (
        <div className="property-modal-overlay" onClick={onClose}>
            <div className="property-modal-content" onClick={e => e.stopPropagation()}>
                <button className="property-modal-close" onClick={onClose}>×</button>
                <img src={imageUrl} alt={property.titulo} className="modal-image" />
                <div className="modal-details">
                    <h2>{property.titulo}</h2>
                    <p className="modal-price">${property.precio.toLocaleString()}</p>
                    <p>{property.descripcion}</p>
                    <p><strong>Características:</strong> {property.caracteristicas}</p>
                </div>
            </div>
        </div>
    );
}